"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Repository = void 0;
class Repository {
    constructor(key) {
        this.projectName = "near-mobile-signer";
        this.key = `${this.projectName}:${key}`;
    }
}
exports.Repository = Repository;
